<template>
  <header>
    <div class="rela">
      <div class="logo-wrap">
        <a href="/">
          <img :src="LogoNm" alt="LogoImg" />
        </a>
      </div>
      <div class="nav-wrap">
        <gnb-list></gnb-list>
      </div>
      <div class="AllMenu-wrap" ref="AllMenuWrap">
        <div class="AllMenu-cont">
          <span>{{ menuPopTxt }}</span>
          <div
            :class="{ isActive: isActive }"
            class="hamburger"
            id="hamburger-11"
          >
            <span class="line"></span>
            <span class="line"></span>
            <span class="line"></span>
          </div>
        </div>
      </div>
    </div>
  </header>
</template>
<script>
import gnbList from 'Components/layout/content/gnbList'
export default {
  data() {
    return {
      menuPopTxt: 'ALL MENU',
      isActive: this.isOn,
    }
  },
  props: {
    isOn: {
      type: Boolean,
      default: false,
    },
    showNavbar: {
      type: Boolean,
      default: false,
    },
    isPageOff: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    isActive() {
      if (this.isActive === true) this.menuPopTxt = 'CLOSE'
      if (this.isActive === false) this.menuPopTxt = 'ALL MENU'
    },
  },
  components: {
    gnbList,
  },
  computed: {
    LogoNm() {
      if (this.showNavbar === true && this.isPageOff === true) {
        return require('../../assets/image/ico/Logo-C.svg')
      } else {
        return require('../../assets/image/ico/Logo-W.svg')
      }
    },
  },
  methods: {
    hamActive() {
      this.isActive = !this.isActive
      this.$emit('hamActive')
    },
  },
  mounted() {
    const AllMenuWrap = document.querySelector('.AllMenu-wrap')
    if (this.isPc) {
      AllMenuWrap.addEventListener('click', this.hamActive)
    } else {
      AllMenuWrap.addEventListener('touchend', this.hamActive)
    }
  },
  beforeDestroy() {
    const AllMenuWrap = document.querySelector('.AllMenu-wrap')
    if (this.isPc) {
      AllMenuWrap.removeEventListener('touchend', this.hamActive)
    } else {
      AllMenuWrap.removeEventListener('click', this.hamActive)
    }
  },
  async created() {},
}
</script>
<style></style>
